import React, {
  useState,
  Fragment,
  useEffect,
  useMemo,
  useCallback,
} from 'react';

import { useUserPages } from 'Auth';
import groupBy from 'lodash/groupBy';

import { LegacySwitchView, Tabs, Tab, SelectMenu } from '@gogame/components';

import { getWidgetsData } from 'scenes/HomeDashboard/widgets';

const EMPTY_OPTIONS = [];

const PresetPickerMenu = ({ options, selectedOptions, onChange, ...props }) => {
  const [
    /* eslint-disable-next-line */
    fixTabButtonsInitialActiveTab,
    setFixTabButtonsInitialActiveTab,
  ] = useState();

  const pages = useUserPages();
  const data = useMemo(
    () =>
      getWidgetsData(options, (permissions) =>
        permissions.some((p) => pages.includes(p))
      ),
    [options, pages]
  );

  const [activeTabId, setActiveTabId] = useState((data[0] || {}).name);

  const handleTabChange = (_e, newActiveTabId) =>
    setActiveTabId(newActiveTabId);

  const selectedOptionsMap = useMemo(() => {
    return groupBy(selectedOptions, 'screen');
  }, [selectedOptions]);

  const handleChange = useCallback(
    (screen) => (screenSelectedOptions) => {
      /* eslint-disable-next-line */
      const { [screen]: omitted, ...other } = selectedOptionsMap;
      onChange(
        [].concat(
          ...Object.keys(other).map((k) => other[k]),
          ...screenSelectedOptions
        )
      );
    },
    [onChange, selectedOptionsMap]
  );

  useEffect(() => {
    setTimeout(() => setFixTabButtonsInitialActiveTab('fixed'), 300);
  }, []);

  return (
    <Fragment>
      <Tabs
        value={activeTabId}
        onChange={handleTabChange}
        variant={'fullWidth'}
      >
        {data.map(({ name, title }) => (
          <Tab
            key={`preset_picker_tab_button_${name}`}
            value={name}
            label={title}
            short={true}
          />
        ))}
      </Tabs>
      <LegacySwitchView activeId={activeTabId}>
        {data.map(({ name, data }) => (
          <LegacySwitchView.Fragment
            key={`preset_picker_tab_${name}`}
            viewId={name}
          >
            <SelectMenu
              {...props}
              options={data}
              selectedOptions={selectedOptionsMap[name] || EMPTY_OPTIONS}
              onChange={handleChange(name)}
            />
          </LegacySwitchView.Fragment>
        ))}
      </LegacySwitchView>
    </Fragment>
  );
};

export default PresetPickerMenu;
